import { useContext, useState } from "react";
import Subtitle from "../subtitle/subtitle";
import {
  AppointmentReviewStyled,
  BaseCards,
  CustomCheckbox,
} from "./appointment-review.styles";
import ReviewCard from "./review-card/review-card";
import {
  StepperContext,
  StepperDataContext,
} from "../../context/stepper-context";
import { SelectedPet } from "../pet-details/types";
import { formatTimeSlot } from "../../../../utils/common-utils";
import ReviewCardPatients from "./review-card-patients/review-card-patients";
import { FormControlLabel } from "@mui/material";

const AppointmentReview: React.FC = () => {
  const {
    selectedClient,
    selectedPatients,
    selectedTimeSlot,
    isRescheduleEnabled,
    setIsRescheduleEnabled,
  } = useContext(StepperDataContext);
  const { setActiveStep } = useContext(StepperContext);

  const { city, state, address, country, zipcode } = selectedClient || {};

  const client = {
    name: `${selectedClient?.first_name} ${selectedClient?.last_name}`,
    content:
      `${address ? address + "," : ""} ${city ? city + "," : ""} ${state ? state + "," : ""} ${country ? country + "," : ""} ${zipcode}`.replace(
        /[\s+,+]$/,
        ""
      ),
  };

  const patients = selectedPatients.map((p: SelectedPet) => {
    return {
      name: p.name,
      content: p.type || p.gender ? `${p.type} ${p.gender}` : "",
      reason: p.reason,
    };
  });

  const timeSlot = {
    name: formatTimeSlot(
      selectedTimeSlot?.start || "",
      selectedTimeSlot?.end || ""
    ),
    content: "Appointment time",
  };

  return (
    <AppointmentReviewStyled>
      <div className="pet-details-header">
        <Subtitle title="Review Appointment" />
      </div>
      <BaseCards>
        <ReviewCard
          onEditClick={() => setActiveStep(0)}
          key="client"
          data={client}
        />
        {/* {patients && patients.map((p, i) => (
                    <ReviewCard onEditClick={() => setActiveStep(1)} key={`patient-${i}`} data={p} />
                ))} */}
        <ReviewCardPatients
          patients={patients}
          onEditClick={() => setActiveStep(1)}
        />
        <ReviewCard
          key="time-slot"
          onEditClick={() => setActiveStep(2)}
          data={timeSlot}
        />
      </BaseCards>
      <FormControlLabel
        control={
          <CustomCheckbox
            checked={isRescheduleEnabled}
            onChange={(e) => setIsRescheduleEnabled(e.target.checked)}
            name="enableReschedule"
            color="primary"
            sx={{
              color: "var(--royal-blue-color)",
              "&.Mui-checked": {
                color: "var(--royal-blue-color)",
              },
              "& .MuiSvgIcon-root": {
                borderRadius: "6px",
              },
            }}
          />
        }
        label="Add Client to the Cancellation List"
      />
    </AppointmentReviewStyled>
  );
};

export default AppointmentReview;
